import { useParams } from 'react-router-dom';

import { ReadonlyProvider } from 'core/readonly';
import Outputs from 'features/outputs/Outputs';
import useProjectQuery from 'shared/api/projects/useProjectQuery';
import MarkedAsFinalNotification from 'shared/projects/MarkedAsFinalNotification';
import useCanEditProject from 'shared/projects/useCanEditProject';

const OutputsPage = () => {
  const { projectId } = useParams();

  const { data: project, isLoading: isProjectLoading } = useProjectQuery(projectId);
  const canEditProject = useCanEditProject(project?.details);

  return (
    <ReadonlyProvider value={!canEditProject}>
      {project?.details.isFinal && <MarkedAsFinalNotification projectId={projectId} />}
      <Outputs projectId={projectId} project={project} isProjectLoading={isProjectLoading || !project} />
    </ReadonlyProvider>
  );
};

export default OutputsPage;
